var rp = require('request-promise').defaults({ json: true });

const api_root = 'https://min-api.cryptocompare.com';
const history = {};

export default {
  history: history,

  getBars: (symbolInfo: any, resolution: any, from: any, to: any, first: any, limit?: any) => {
    var split_symbol = symbolInfo.name.split(/[:/]/);
    const url =
      resolution === 'D'
        ? '/data/histoday'
        : resolution >= 60
          ? '/data/histohour'
          : '/data/histominute';
    const qs = {
      e: split_symbol[0],
      fsym: split_symbol[1],
      tsym: split_symbol[2],
      toTs: to ? to : '',
      limit: limit ? limit : 2000,
      // aggregate: 1//resolution
    };
    // console.log({qs})

    return rp({
      url: `${api_root}${url}`,
      qs,
    }).then((data: any) => {
      console.log({ data });
      if (data.Response && data.Response === 'Error') {
        console.log('CryptoCompare API error:', data.Message);
        return [];
      }
      if (data.Data.length) {
        console.log(
          `Actually returned: ${new Date(data.TimeFrom * 1000).toISOString()} - ${new Date(
            data.TimeTo * 1000,
          ).toISOString()}`,
        );
        var bars = data.Data.map((el: any) => {
          return {
            time: el.time * 1000, //TradingView requires bar time in ms
            low: el.low,
            high: el.high,
            open: el.open,
            close: el.close,
            volume: el.volumefrom,
          };
        });
        if (first) {
          var lastBar = bars[bars.length - 1];
          history[symbolInfo.name] = { lastBar: lastBar };
        }
        return bars;
      } else {
        return [];
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/historyProvider.ts